import React from 'react';
import {Stack} from "@mui/joy";
import VariableRepresentation from "../AI/VariableRepresentation";

// components


class RouteStateAgentCall extends React.Component {


    render() {

        return (
            <Stack
                my={1}
                direction={'row'}
                spacing={1}
                useFlexGap
                sx={{
                    flexWrap: 'wrap',
                    alignItems: 'center',
                }}
            >
                {
                    Object.entries(
                        this.props.call.agent_run.result_variables
                    ).filter(
                        e => this.props.call.agent_run.agent.result_variables[e[0]]?.featured
                    ).map(k => (
                        <VariableRepresentation
                            name={this.props.call.agent_run.agent.result_variables[k[0]]?.title || k[0]}
                            value={k[1]}
                            type={this.props.call.agent_run.agent.result_variables[k[0]]?.type}
                        />
                    ))
                }
            </Stack>
        )
    }
}

export default RouteStateAgentCall;
